/* eslint-disable react/jsx-no-bind */
import React, { useState } from 'react';
import { useParams } from 'react-router-dom'
import queryString from 'query-string';
import config from '../config.js'
import xhr from 'xhr';
import xtend from 'xtend';
import _ from 'underscore';
import urlJoin from 'url-join';
import WorkspaceHeader from '../common/components/WorkspaceHeader'
import Loader from '../common/components/notifications/Loader';
import { useForm } from "react-hook-form";

var URL = urlJoin(process.env.CRUD_API, 'Accounts');
function validatePassword (val) {
    var re = /^(?=.*[a-z])(?=.*\d).+$/g;
    var test = re.test(val);
    return test && val.length >= 8;
}


const ResetForm = (props) => {
    const mediumRegex = new RegExp("^(((?=.*[a-z])(?=.*[A-Z]))|((?=.*[a-z])(?=.*[0-9]))|((?=.*[A-Z])(?=.*[0-9])))(?=.{6,})");
    const { register, handleSubmit, errors, triggerValidation, watch } = useForm({
        mode: "onChange"
    });
    const [isCalling, setIsCalling] = useState(false);
    const [hasError, setHasError] = useState(false);
    const [resetOk, setResetOk] = useState(false);

    const onSubmit = data => {
        let payload = {
            'token': props.token,
            'email': props.email,
            'password': data.password
        }
        // call the db
        setIsCalling(true);
        xhr({
            headers: {
                "Authorization": config.apiAuthentication.vendorName,
                "wsc-api-key": config.apiAuthentication.vendorKey
            },
            method: 'POST',
            url: urlJoin(URL, 'resetPassword'),
            body: JSON.stringify(payload),
            encoding: undefined
        }, function onResp (err, resp, body) {

            const respData = JSON.parse(body);
            if (respData.errors.hasError){
                setIsCalling(false)
                setHasError(true);
            } else {
                setResetOk(true)
                setIsCalling(false)
                // redirect to login
                window.location = '/';
            }
        })

    }

    return (
        <div>
            {(isCalling)
                ? <Loader /> :
                (hasError)
                    ? <Error message={'This password reset request is not valid. please check the link you were issued or contact support@invintus.com'}/> :
                    (!resetOk)
                        ?
                        <div className="container">
                            <div className="col-sm-6 col-sm-offset-3">
                                <h2>Welcome to Invintus</h2>
                                <form onSubmit={handleSubmit(onSubmit)} className="panel panel-body" style={{padding: '2em 0'}}>
                                    <div className="row validation-wrapper" style={{
                                        marginBottom: '2em'
                                    }}>
                                        <div className="col-sm-6 col-sm-offset-3">
                                            <h5>{props.firstName},</h5> <h4>Start here to setup your password</h4>
                                            <p>Username is: {props.email}</p>
                                        </div>
                                    </div>
                                    <div className="row validation-wrapper" style={{
                                        marginBottom: '2em'
                                    }}>
                                        <div className="col-sm-6 col-sm-offset-3">

                                            <input type="password" placeholder="New Password" name="password" ref={register({
                                                required: "this is required",
                                                pattern: {
                                                    value: mediumRegex,
                                                    message: "requires least 8 characters and at least 1 number"
                                                }
                                            })} style={{ width: "250px" }} />
                                            {errors.password && <p>{errors.password.message}</p>}

                                        </div>
                                    </div>
                                    <div className="row validation-wrapper" style={{
                                        marginBottom: '1em'
                                    }}>
                                        <div className="col-sm-6 col-sm-offset-3">
                                            <input type="password" name="newPassword" ref={register({
                                                validate: (value) => value === watch('password') || "Passwords don't match."})} placeholder="Confirm Password" required
                                            style={{ width: "250px" }}
                                            />
                                            {/* errors will return when field validation fails  */}
                                            {errors.newPassword && <p>{errors.newPassword.message}</p>}
                                        </div>

                                    </div>
                                    <div className="row">
                                        <div className="col-sm-6 col-sm-offset-3 text-right">
                                            <button
                                                type="submit"
                                                // disabled={(!isValid)}
                                                className="btn btn-primary"
                                            >
                                        Set Password
                                            </button>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div> :

                        <div className="container">
                            <div className="col-sm-6 col-sm-offset-3">
                                <h2>all set! please <a href="/">login</a></h2>
                            </div>
                        </div>}
        </div>

    );
}


const Error = (props) => {

    return (

        <div className="container">
            <div className="alert alert-danger">
                {props.code ? (<h4>Error: <code>{props.code}</code></h4>) :
                    (<h4>Error</h4>)}
                {props.message}
            </div>
        </div>

    )
}


const SetPassword = (props) => {
    const parsed = queryString.parse(props.location.search);
    let { token } = useParams()
    const [isLoading, setIsLoading] = useState(true);
    const [hasError, setHasError] = useState(false);

    let firstLoadData = {
        'token': token,
        'email': parsed.e
    }

    const [firstCallResponse, setFirstCallResponse] = useState(() =>{
        if (isLoading) {
            xhr({
                headers: {
                    "Authorization": config.apiAuthentication.vendorName,
                    "wsc-api-key": config.apiAuthentication.vendorKey
                },
                method: 'POST',
                url: urlJoin(URL, 'validateToken'),
                body: JSON.stringify(firstLoadData),
                encoding: undefined
            }, function onResp (err, resp, body) {

                const respData = JSON.parse(body);
                if (respData.errors.hasError){
                    setIsLoading(false)
                    setHasError(true);
                } else {
                    setIsLoading(false)
                    setFirstCallResponse(respData.data)
                }
            })
        }

    });

    var style = isLoading ? { opacity: 0.4 } : {};
    style = xtend(style, { transition: 'opacity .25s' });
    return (
        <div id="workspace-wrapper">
            <WorkspaceHeader landing={true} />
            <div id="workspace-content-wrapper">
                <div id="workspace-content">
                    <main style={style}>
                        {
                            (isLoading) ? <Loader /> :
                                (hasError) ? <Error message={'This password reset request is not valid. please check the link you were issued or contact support@invintus.com'}/> :
                                    <ResetForm {...firstCallResponse}/>
                        }
                    </main>
                </div>
            </div>
        </div>

    );
}

export default SetPassword;